import Table from "../../../../../components/Table";

function ReceiptsTable({
  objects,
  onSort,
  schema,
  selected,
  onCollapse,
  suppliers,
  showProgress,
  hideProgress,
  excludeFields,
  onEdit,
  onDelete,
  ...props
}) {
  const actions = [
    {
      label: "Edit",
      icon: "bi bi-pencil",
      className: "btn btn-primary text-white btn-sm fw-medium",
      onClick: (object) => {
        onEdit(object);
      },
    },
    {
      label: "Delete",
      icon: "bi bi-trash",
      className: "btn btn-danger text-white btn-sm fw-medium",
      onClick: (object) => {
        onDelete(object);
      },
    },
  ];
  return (
    <>
      <div className="d-flex flex-column overflow-auto">
        <Table
          fields={schema.fields}
          //   onClick={this.clickData.bind(this)}
          onCollapse={onCollapse}
          collapsable
          objects={objects}
          excludeFields={Object.keys(schema.fields).reduce(
            (acc, key) => {
              const options = schema.fields[key];
              if (options.read === false || options._read === false) {
                acc.push(key);
              }
              switch (options._type || options.type) {
                case "Relation":
                case "Array":
                case "Object":
                case "File":
                  acc.push(key);
                  break;
                default:
              }
              return acc;
            },
            ["acl", "id", "created", "updated", ...excludeFields],
          )}
          selected={selected}
          //   onSelect={this.onSelect.bind(this)}
          //   onSelectAll={this.onSelectAll.bind(this)}
          //   progress={progress}
          //   onClickItem={this.onClickItem.bind(this)}
          onSort={onSort}
          className="mt-1"
          actions={actions}
        />
      </div>
    </>
  );
}

export default ReceiptsTable;
